import React, { HTMLAttributes } from 'react';
import ContentCard from '../ContentCard';
import Link from '../../../../../shared/Link/Link';
import { DiscoveryModule } from '../../../../../../store/features/discovery';
import { useRootSelector } from '../../../../../../store/hooks';
import { selectPageConfig } from '../../../../../../store/features/pageConfig';
import styles from './ModuleCard.module.scss';

export interface ModuleCardProps
  extends Pick<HTMLAttributes<HTMLDivElement>, 'className'> {
  data: DiscoveryModule;
}

export function ModuleCard(props: ModuleCardProps) {
  const { pageName, moduleTitle, content, id } = props.data;
  const { sitePath } = useRootSelector(selectPageConfig);
  const title = `${moduleTitle ? moduleTitle + ', ' : ''}${pageName}`;
  const renderTitle = <div className={styles.title}>{title}</div>;
  const renderDescription = <div className={styles.description}>{content}</div>;

  return (
    <Link to={`/${sitePath}/${id}`} className={styles.link}>
      <ContentCard
        title={renderTitle}
        description={renderDescription}
        className="site-card"
      />
    </Link>
  );
}
